import { render } from "./accordion.vue?vue&type=template&id=7f1c15e8&scoped=true"
import script from "./accordion.vue?vue&type=script&lang=js"
export * from "./accordion.vue?vue&type=script&lang=js"

import "./accordion.vue?vue&type=style&index=0&id=7f1c15e8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f1c15e8"]])

export default __exports__